import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import "../Styles/Checkout.css";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import CheckoutForm from "./CheckoutForm";


const stripePromise = loadStripe(
  "pk_test_51NvJ3kKPbB15KryNvGgstnfsKT3QVJ5C2xiOAOBFYOl4DU2yo8pRzzEawpDZqKfpMHgqk4WAYHXiqaSuKImoO2BN00OaLSIYbR"
);

const Checkout = () => {
  const [page, setPage] = useState(0);
  const [cart, setCart] = useState([]);
  const [subTotal, setSubTotal] = useState(0.0);
  const [total, setTotal] = useState(0.0);

  const navigate = useNavigate();

  const increaseQuantity = (id) => {
    const productToEdit = cart.find((item) => item.id === id);
    if (productToEdit) {
      productToEdit.qty += 1;
    }

    localStorage.setItem("cart", JSON.stringify(cart));
  };
  const decreaseQuantity = (id) => {
    const productToEdit = cart.find((item) => item.id === id);
    if (productToEdit) {
      productToEdit.qty === 1
        ? (productToEdit.qty = 1)
        : (productToEdit.qty -= 1);
    }

    localStorage.setItem("cart", JSON.stringify(cart));
  };

  const removeItem = (id) => {
    const productToRemove = cart.findIndex((item) => item.id === id);
    if (productToRemove !== -1) {
      cart.splice(productToRemove, 1);
    }

    localStorage.setItem("cart", JSON.stringify(cart));
  };

  useEffect(() => {
    let cart = localStorage.getItem("cart");
    if (!cart) {
      setCart([]);
    } else {
      setCart(JSON.parse(cart));
      let cart2 = JSON.parse(cart);
      let total = cart2.reduce((a, b) => a + b.discountPrice * b.qty, 0);
      let sub = cart2.reduce((a, b) => a + b.discountPrice, 0);
      setTotal(total);
      setSubTotal(sub);
    }
  }, [increaseQuantity, decreaseQuantity]);

  return (
    <>
      <Navbar />

      <div className="cartDetailsWrapper">
        <div className="leftCheckout">
          <div className="cartProducts">
            <h1>Products({cart.length})</h1>
            {cart.map((data) => {
              return (
                <div className="cartCard">
                  <div className="leftCartInner">
                    <img src={data.images && data.images[0].url} alt="" />
                    <div className="cartDetails">
                      <div className="cartDetailsHeading">
                        <h3>{data.name}</h3>
                        <h2>${data.discountPrice}</h2>
                      </div>
                      <p className="description">{data.description}</p>
                      <div className="cartDetailsBottom">
                        <p>
                          <span>Category:</span> {data.category}
                        </p>
                        <div className="qty">
                          <p>Qty: {data.qty}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <Elements stripe={stripePromise}>
            <CheckoutForm total={total}/>
          </Elements>
        </div>
        <div className="rightCheckout">
          <h1>Summary</h1>
          <div className="summary">
            <p>
              <span>Quantity: </span> {cart.length}
            </p>
            <p>
              <span>Subtotal: </span> N{subTotal}
            </p>
            <p>
              <span>Total: </span> N{total && total.toFixed(2)}
            </p>
          </div>
          <div className="buttonWrap">
            <button>Pay Now</button>
            <button onClick={() => navigate("/product")}>
              Continue Shopping
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Checkout;
